import React from 'react';
import { ITableColumns, ITableDataSource } from 'models/table';
import { MenuButton } from 'components/molecules/MenuButton';
import { EIconTypes } from 'constants/Icons';
import { Chips, EChipsVariants } from 'components/atoms/Chips';
import { format, parseISO } from 'date-fns';
import { ApplicationStatus, IApplication } from 'models/application';

interface IMyApplicationsTableColumns {
  handleAddAttachment: (arg: string) => void;
  handleShowDetails: (arg: string) => void;
  handlePayNow: (arg: string) => void;
  handleAppeal: (arg: string) => void;
  statusVariant: (arg: string) => EChipsVariants;
  t: (key: string) => string;
}

export const mapApplicationToDataSource = (applications: IApplication[]): ITableDataSource[] =>
  applications.map((application) => ({
    id: application.uuid,
    status: application.status,
    name: application.name,
    createdDate: parseISO(application.createdDate),
  }));

export const myApplicationsTableColumns = ({
  handleAddAttachment,
  handleShowDetails,
  handlePayNow,
  handleAppeal,
  statusVariant,
  t,
}: IMyApplicationsTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-abc0-304a6f32f511',
    key: 'name',
    title: 'Application Name',
    isSortable: false,
  },
  {
    id: 'f0504ca5-6b32-482d-abc1-304a6f32f511',
    key: 'createdDate',
    title: 'Creation Date',
    width: '200px',
    isSortable: false,
    render: (_data, props) =>
      props.createdDate ? format(props.createdDate, 'dd-MM-yyyy HH:ii') : '--',
  },
  {
    id: 'f0504ca5-6b32-482d-abc2-304a6f32f511',
    key: 'status',
    title: 'Status',
    isSortable: false,
    render: (_data, props) => (
      <Chips
        text={t(`applicationStatus.${props.status}`)}
        variant={statusVariant(props.status)}
      />
    ),
  },
  {
    id: 'f0504ca5-6b32-482d-ab32-304a6f32f511',
    key: 'status',
    title: 'Stage',
    isSortable: false,
    render: () => 'N/A',
  },
  {
    id: 'f0504ca5-6b32-482d-a269-304a6f32f511',
    key: '',
    width: '100px',
    align: 'center',
    title: 'Actions',
    isCenterTableHead: true,
    isSortable: false,
    render: (_data, props) => (
      <MenuButton
        id={props.id}
        items={
          props.status === ApplicationStatus.Drafting
            ? [
                {
                  name: 'Add attachment',
                  icon: EIconTypes.administration,
                  handler: () => {
                    handleAddAttachment(props.id);
                  },
                },
                {
                  name: 'Show details',
                  icon: EIconTypes.view,
                  handler: () => {
                    handleShowDetails(props.id);
                  },
                },
                {
                  name: 'Pay now',
                  icon: EIconTypes.plus1,
                  disabled: true,
                  handler: () => {
                    handlePayNow(props.id);
                  },
                },
              ]
            : [
                {
                  name: 'Appeal',
                  icon: EIconTypes.administration,
                  handler: () => {
                    handleAppeal(props.id);
                  },
                },
                {
                  name: 'Show details',
                  icon: EIconTypes.view,
                  handler: () => {
                    handleShowDetails(props.id);
                  },
                },
              ]
        }
      />
    ),
  },
];
